import { shiftEditorViewState } from "..";
import { Moment } from "moment";
import { mutatorAction } from "satcheljs";

export default mutatorAction("updateEndDateTimeoff", function updateEndDateTimeoff(endDate: Moment) {
    if (endDate) {
        shiftEditorViewState().timeOffEndDate = endDate.clone();
    }
});
